import apiClient from '../../../lib/client';

/**
 * User addresses API functions
 * Manage user's saved residential and mailing addresses
 */

export const addressesAPI = {
  /**
   * Get all saved addresses for current user
   */
  listAddresses: async () => {
    const { data } = await apiClient.get('/addresses');
    return data;
  },

  /**
   * Create a new saved address
   */
  createAddress: async (addressData) => {
    const { data } = await apiClient.post('/addresses', addressData);
    return data;
  },

  /**
   * Get a specific address by ID
   */
  getAddress: async (addressId) => {
    const { data } = await apiClient.get(`/addresses/${addressId}`);
    return data;
  },

  /**
   * Update an existing address
   */
  updateAddress: async (addressId, updates) => {
    const { data } = await apiClient.patch(`/addresses/${addressId}`, updates);
    return data;
  },

  /**
   * Delete an address
   */
  deleteAddress: async (addressId) => {
    const { data } = await apiClient.delete(`/addresses/${addressId}`);
    return data;
  },

  /**
   * Set an address as the primary address
   */
  setPrimaryAddress: async (addressId) => {
    const { data } = await apiClient.post(`/addresses/${addressId}/set-primary`);
    return data;
  },
};
